import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import EventToAsyncDecorator from '../../../plugins/eventToAsyncDecorator'
import SearchFilterRequest from '../../../Spirit/Admin/Interfaces/Models/Common/SearchFilterRequest';
import ReminderUpdateRequest from '../../../Spirit/Admin/Interfaces/Models/ReminderService/ReminderUpdateRequest';
import WsResponseModelT from '../../../SchemaBuilderServer/Models/WsResponseModelT';
import PaginationResponseT from '../../../Common/ResponseModels/PaginationResponseT';
import ReminderGetListResponse from '../../../Spirit/Admin/Interfaces/Models/ReminderService/ReminderGetListResponse';
import GetReminderResponse from '../../../Spirit/Admin/Interfaces/Models/ReminderService/GetReminderResponse';

export default class ReminderService {
	webApiService: WebApiService;
	DeleteEvent = new Events<WsResponseModelT<Boolean>>();
	GetListEvent = new Events<WsResponseModelT<PaginationResponseT<ReminderGetListResponse>>>();
	GetReminderEvent = new Events<WsResponseModelT<GetReminderResponse>>();
	UpdateEvent = new Events<WsResponseModelT<Boolean>>();
	constructor(webApiService: WebApiService) {
		const self = this;
		this.webApiService = webApiService;
		webApiService.on('ReminderService', 'Delete', (res: WsResponseModelT<Boolean>) => {
			self.DeleteEvent.trigger(res);
		});
		webApiService.on('ReminderService', 'GetList', (res: WsResponseModelT<PaginationResponseT<ReminderGetListResponse>>) => {
			self.GetListEvent.trigger(res);
		});
		webApiService.on('ReminderService', 'GetReminder', (res: WsResponseModelT<GetReminderResponse>) => {
			self.GetReminderEvent.trigger(res);
		});
		webApiService.on('ReminderService', 'Update', (res: WsResponseModelT<Boolean>) => {
			self.UpdateEvent.trigger(res);
		});
	}
	Delete(id: number = 0) { 	
        this.webApiService.send('ReminderService', 'Delete' , id);
    }
	GetList(request: SearchFilterRequest = null) { 	
        this.webApiService.send('ReminderService', 'GetList' , request);
    }
	GetReminder(id: number = 0) { 	
        this.webApiService.send('ReminderService', 'GetReminder' , id);
    }
	Update(request: ReminderUpdateRequest = null) { 	
        this.webApiService.send('ReminderService', 'Update' , request);
    }
	 // async methods
	async deleteAsync(id: number = 0): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.Delete.bind(this), this.DeleteEvent)(id);
	}
	async getListAsync(request: SearchFilterRequest = null): Promise<PaginationResponseT<ReminderGetListResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetList.bind(this), this.GetListEvent)(request);
	}
	async getReminderAsync(id: number = 0): Promise<GetReminderResponse> {
		return EventToAsyncDecorator.getInstance().bind(this.GetReminder.bind(this), this.GetReminderEvent)(id);
	}
	async updateAsync(request: ReminderUpdateRequest = null): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.Update.bind(this), this.UpdateEvent)(request);
	}
}